/** Phase 1 Public Discovery — anonymous API surface. */
import { apiClient } from "./client";

export async function getPublicFeed(vertical, params = {}) {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== ""),
  );
  const r = await apiClient.get(`/public/discovery/feed/${vertical}`, { params: clean });
  return r.data;
}

export async function getPublicListing(ulid) {
  const r = await apiClient.get(`/public/discovery/listing/${ulid}`);
  return r.data;
}

export async function getPublicHeatmap(metric, params = {}) {
  const r = await apiClient.get(`/public/discovery/heatmap/${metric}`, { params });
  return r.data;
}

export async function getPublicFilterOptions(vertical, params = {}) {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== ""),
  );
  const r = await apiClient.get(`/public/discovery/filter-options/${vertical}`, {
    params: clean,
  });
  return r.data;
}

export async function getPublicLocations(q, params = {}) {
  const { vertical = "immo", ...rest } = params;
  const clean = Object.fromEntries(
    Object.entries(rest).filter(([, v]) => v !== null && v !== undefined && v !== ""),
  );
  const r = await apiClient.get(`/public/discovery/locations/${vertical}`, {
    params: { q, ...clean },
  });
  return r.data;
}

export async function getBillingProducts() {
  const r = await apiClient.get("/billing/products");
  return r.data;
}

export async function getPublicStats() {
  const r = await apiClient.get("/public/stats");
  return r.data;
}
